import {Base} from "@/api/Base"

export class MpfSettingEdit extends Base {
    path = "mpfSetting/edit"
}